export default __webpack_public_path__ + "static/news-img4-75f1631afad96319b6f265acbac2c7ab.png";